import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import CircularProgress from 'apollo-react/components/CircularProgress';
import { useAuth } from '../../../contexts/AuthContext';
import '../RouteGuard/RouteGuard.css';

/**
 * Authentication gate.
 *
 * Redirects unauthenticated users to /login for protected routes.
 * Public routes are handled separately in route structure.
 */
const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="route-guard-loading">
        <CircularProgress />
      </div>
    );
  }

  // Redirect unauthenticated users to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
